import { useContext } from "react";
import { TagContext } from "../contexts/TagContext";

export const useTag = () => useContext(TagContext);
